import * as React from "react";
import { action } from "mobx";
import { inject, observer } from "mobx-react";
import { AppProps } from "../../stores/storeContract";
import { View } from "../../stores/commonStore";
import SymbolSelect from "../symbolselect/SymbolSelect";
import "./Settings.scss";
import SymbolSelectSimple from "../symbolselect/SymbolSelectSimple";

@inject("settingsStore", "commonStore", "symbolStore", "userStore")
@observer
export default class Settings extends React.Component<AppProps> {
  
	@action.bound onTelegramBotTokenChange(e: any): void {
		this.props.settingsStore.settings.telegramBotToken = e.target.value;
	}

	@action.bound onTelegramChatIdChange(e: any): void {
		this.props.settingsStore.settings.telegramChatId = e.target.value;
	}

	@action.bound onApiUrlChange(e: any): void {
		this.props.settingsStore.settings.apiUrl = e.target.value;
	}

	@action.bound onAdminPostChange(e: any): void {
		this.props.settingsStore.adminPost = e.target.value;
	}

	 @action.bound save(): void {
		 // error msg handled in saveSettings()
		this.props.settingsStore.saveSettings().then(() => this.props.commonStore.view = View.Scanner, () => {});
	}

	@action.bound saveSyncedSymbols(): void {
		// error msg displayed from saveSyncedSymbols()
		this.props.symbolStore.saveSyncedSymbols();
	}

	render() {

		const { settings, adminPost, pushAdminPost, testTelegramSettings } = this.props.settingsStore;
		const { isAdmin } = this.props.userStore;

		var symbolSelectProps = {
			symbolSelect: settings,
			commonStore: this.props.commonStore,
			excludedSymbols: [] as string[]
		}

		const { syncedSymbols } = this.props.symbolStore;

		var symbolSelectAddProps = {
			symbolSelect: syncedSymbols.addSyncedSymbol,
			commonStore: this.props.commonStore
		}

		var symbolSelectRemoveProps = {
			symbolSelect: syncedSymbols.removeSyncedSymbol,
			commonStore: this.props.commonStore
		}		

		return (
			<div className="settings">
				
				<div className="row">
					<div className="col-md-6">
						<div className="settings-section">
							<span className="settings-label">Telegram Settings</span>

							<p><br /><b>How to get Telegram bot API token and chat ID</b></p>
							<p>Go to the Telegram app on your device and complete following steps:</p>
							<p><b>Step 1:</b> Find telegram bot named "@botfather" (marked with blue approval icon) and start conversation with this bot</p>
							<p><b>Step 2:</b> To create a new bot type “/newbot”</p>
							<p><b>Step 3:</b> Provide name and username for new bot according instructions</p>
							<p><b>Step 4:</b> You will see a new API token. Copy your API token to the field below. Store API token also on some different safe place</p>
							<p><b>Example of bot API token:</b> 1234567890:AKEdR4BDK28D_ALF89FSEDFeFDbE_2RjPW9</p>
					
							<p><b>Step 5:</b> Create a group/channel. Mark your group/channel as private to avoid unauthorized members to join</p>
							<p><b>Step 6:</b> Use google to find a tutorial how to get chat ID</p>
							<p>(there are many bots which can provide the chat ID. Just add such bot to group/channel and don't forget to remove it afterwards)</p>
							<p><b>Example of Chat ID:</b> -1001234567890</p>
							<p><b>Step 7:</b> Add your new bot (created in step 1-4) into the group/channel</p>							
							<br />

							<div className="input-group mb-3">
								<div className="input-group-prepend">
									<span className="input-group-text settings-prepend-text" id="basic-addon1">Bot API Token</span>
								</div>
								<input type="text" 
									className="form-control" 
									aria-label="Bot Token" 
									aria-describedby="basic-addon1" 
									value={settings.telegramBotToken} 
									onChange={this.onTelegramBotTokenChange} />
							</div>

							<div className="input-group mb-3">
								<div className="input-group-prepend">
									<span className="input-group-text settings-prepend-text" id="basic-addon2">Chat ID</span>
								</div>
								<input type="text" 
									className="form-control" 
									aria-label="Chat ID" 
									aria-describedby="basic-addon2" 
									value={settings.telegramChatId} 
									onChange={this.onTelegramChatIdChange} />
							</div>
							<button className="btn btn-outline-success btn-sm" onClick={testTelegramSettings}>
								Send test message
							</button>
						</div>

						<div className="settings-section">
							<span className="settings-label">External API Settings</span>

							<p><br />Allows to send changes to external API (e.g. bot)</p>
							<br />

							<div className="input-group mb-3">
								<div className="input-group-prepend">
									<span className="input-group-text settings-prepend-text" id="basic-addon3">API URL</span>
								</div>
								<input type="text" 
									className="form-control" 
									aria-label="API URL" 
									aria-describedby="basic-addon3" 
									value={settings.apiUrl} 
									onChange={this.onApiUrlChange} />
							</div>
						</div>

						<div className={isAdmin ? 'settings-section' : 'hidden'}>
							<span className="settings-label">Admin posts</span>

							<div className="input-group mb-3">
								<div className="input-group-prepend">
									<span className="input-group-text settings-prepend-text" id="basic-addon3">Message</span>
								</div>
								<input type="text" 
									className="form-control" 
									aria-label="Message" 
									aria-describedby="basic-addon3" 
									value={adminPost} 
									onChange={this.onAdminPostChange} />
							</div>

							<button className="btn btn-outline-success btn-sm" onClick={pushAdminPost}>
							Send message
							</button>							
						</div>
					</div>
					<div className="col-md-3">
						<div className="settings-section">
							<span className="settings-label">Chart & Trades</span>

							<br /><br />

							<span className="radio-option"><input type="radio" checked={settings.extendedRowVisible == false} onChange={() => settings.extendedRowVisible = false} />Hide</span>
							<span className="radio-option"><input type="radio" checked={settings.extendedRowVisible == true} onChange={() => settings.extendedRowVisible = true} />Show</span>							
						</div>

						<div className="settings-section">
							<span className="settings-label">Default currency for Volume</span>

							<br /><br />

							<span className="radio-option"><input type="radio" checked={settings.volumeDefaultView == 0} onChange={() => settings.volumeDefaultView = 0} />Quote</span>
							<span className="radio-option"><input type="radio" checked={settings.volumeDefaultView == 1} onChange={() => settings.volumeDefaultView = 1} />Base</span>
							<span className="radio-option"><input type="radio" checked={settings.volumeDefaultView == 2} onChange={() => settings.volumeDefaultView = 2} />USD</span>
						</div>
					</div>
					<div className="col-md-3">						
						<div className={isAdmin ? 'settings-section' : 'hidden'}>
							<span className="settings-label">Add/Remove trading pairs</span>

							<p><br />Remove delisted trading pairs from filters. Add new pairs to filters if filter allows it</p>
							<br />

							<div className="row">
								<div className="col-md-4">
									<span className="settings-label">Pairs to add</span>	
									<SymbolSelectSimple {...symbolSelectAddProps} />
								</div>
								<div className="col-md-4">
									<span className="settings-label">Pairs to remove</span>	
									<SymbolSelectSimple {...symbolSelectRemoveProps} />
								</div>
								<div className="col-md-4">										
									<button className="btn btn-outline-success btn-sm" onClick={this.saveSyncedSymbols}>
										<i className="fas fa-refresh"></i> Sync
									</button>
								</div>											
							</div>
						</div>

						<div className="settings-section">
							<span className="settings-label">Exclude trading pairs from filters</span>

							<p><br />Filter out currencies from filters (e.g. which require user verification)</p>
							<br />

							<SymbolSelect {...symbolSelectProps} />
						</div>						
					</div>
				</div>

				<button className="btn btn-outline-secondary btn-sm" onClick={() => this.props.commonStore.view = View.Scanner}>
					<i className="fas fa-chevron-left"></i> Back
				</button>
				<button className="btn btn-outline-success btn-sm" onClick={this.save}>
					<i className="fas fa-save"></i> Save
				</button>				
			</div>
		);
	}
}